import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResponseCustomizationWifi } from "../../types/common";
import { getListDataWifi } from "../../methods/Methods";

export interface FillMyNetworkSliceInterface {
    clientId: string;
}

export interface MyNetworkData extends ResponseCustomizationWifi {
    clientId: string;
}

const myNetworkInitialState: MyNetworkData = {
    clientId: "",
    status: false,
    message: "",
    intentos_disponibles: 0,
    migrado_ACS: false,
    data: []
};

const fillMyNetworkSlice = createAsyncThunk(
    "thunk/myNetwork",
    async (obj: FillMyNetworkSliceInterface): Promise<MyNetworkData> => {
        let dataResponse: MyNetworkData = {
            clientId: obj.clientId,
            status: false,
            message: '',
            intentos_disponibles: 0,
            migrado_ACS: false,
            data: [],
        };
        await getListDataWifi(obj.clientId).then((response) => {
            if (response && response.data.data[0]) {
                dataResponse.status = response.data.data[0].status;
                dataResponse.message = response.data.data[0].message;
                dataResponse.intentos_disponibles = response.data.data[0].intentos_disponibles;
                dataResponse.data = response.data.data[0].data;
                dataResponse.migrado_ACS = response.data.data[0].migrado_ACS
            }
        }).catch(() => { });

        return dataResponse;
    }
);

const myNetworkSlice = createSlice({
    name: "myNetwork",
    initialState: myNetworkInitialState,
    reducers: {
        setMyNetworkData: (state, action: PayloadAction<MyNetworkData>) => {
            state.clientId = action.payload.clientId;
            state.status = action.payload.status;
            state.message = action.payload.message;
            state.intentos_disponibles = action.payload.intentos_disponibles;
            state.migrado_ACS = action.payload.migrado_ACS;
            state.data = action.payload.data;
        },
        clearMyNetworkData: (action) => {
            action.clientId = myNetworkInitialState.clientId;
            action.status = myNetworkInitialState.status;
            action.message = myNetworkInitialState.message;
            action.intentos_disponibles = myNetworkInitialState.intentos_disponibles;
            action.migrado_ACS = myNetworkInitialState.migrado_ACS;
            action.data = myNetworkInitialState.data;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fillMyNetworkSlice.fulfilled, (state, action) => {
            state.clientId = action.payload.clientId;
            state.status = action.payload.status;
            state.message = action.payload.message;
            state.intentos_disponibles = action.payload.intentos_disponibles;
            state.migrado_ACS = action.payload.migrado_ACS;
            state.data = action.payload.data;
        });
    }
});

export { fillMyNetworkSlice };
export const {
    setMyNetworkData,
    clearMyNetworkData,
} = myNetworkSlice.actions;

export const getMyNetworklData = (state: any) => state.megaMovil as MyNetworkData;

export default myNetworkSlice.reducer;
